module.exports = __webpack_public_path__ + "static/media/hamburger-icon-index.2db385ef.svg";